import React from 'react'
import ReactTimeout from 'react-timeout'
import {Alert} from 'react-bootstrap'

class SuccessMsg extends React.Component {

  constructor(props) {
    super(props)
    this.state={show:false}
    this.hideMessage = this.hideMessage.bind(this)
    this.hideMessage()
  }

  hideMessage() {
    setTimeout(()=>{
      this.setState({show:false})
    }, 1000)
  }

  render(){
    if(this.state.show) {
        return <div style={{position:'fixed', width:200,marginLeft: -100, left:'50%', top:2}}><Alert   bsStyle="success">Deleted Successfully</Alert></div>
    }
    else {
      return null
    }

  }
}

export default ReactTimeout(SuccessMsg);



// WEBPACK FOOTER //
// ./src/utils/successmsg.js